<template>
  <div>
    <title-edit header="Service" />
    <line-hr />
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        &nbsp;
      </v-col>
      <v-col cols="12" sm="8"  xs="12" style="float: right">
        <v-app class="switch-app">
          <v-switch label="Publish" color="tcdc_color" v-model="form.is_publish"></v-switch>
        </v-app>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Order :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-text-field />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Branch* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <select-option :items="optionBranch" :model="form.branch_id" @update="updateBranch" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Service name TH* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-text-field :model="form.title_th" @update="updateNameTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Service name EN* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-text-field :model="form.title_en" @update="updateNameEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Description TH* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-editor :model="form.description_th" id="1" @update="updateDescriptionTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Description EN* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-editor :model="form.description_en" id="2" @update="updateDescriptionEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Slug Url :</label>
      </v-col>
      <v-col cols="6" sm="8"  xs="12">
        <input-text-field :model="form.slug_url" @update="updateSlugUrl" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Image Icon :</label>
        <div style="color: #2E8037; font-size: 12px">
          *รองรับ JPEG ,PNG ขนาดไฟล์ไม่เกิน 700 x 700 px
        </div>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-image-upload
          height="140px"
          width="140px"
          col="col-6"
          id="input1"
          menu="service"
          :model="form.icon_show"
          @update="updateImageIcon"
        />
      </v-col>
    </div>
    <line-hr />
    <div class="row" style="margin-right: 30px">
      <v-spacer></v-spacer>
      <delete-button @click.native="deleteService" />
<!--      <preview-button />-->
      <save-button @click.native="saveService" />
    </div>
  </div>
</template>

<script>
import SelectOption from "../../../components/Input/selectOption";
import InputTextField from "../../../components/Input/InputTextField";
import InputEditor from "../../../components/Input/InputEditor";
import InputImageUpload from "../../../components/Input/InputImageUpload";
import TitleEdit from "../../../components/TitleHeader/TitleEdit";
import DeleteButton from "../../../components/Button/DeleteButton";
import PreviewButton from "../../../components/Button/PreviewButton";
import SaveButton from "../../../components/Button/SaveButton";
import LineHr from "../../../components/Icon/line-hr";
import SwitchSelect from "../../../components/Input/StyleUtility";
import { mapState } from "vuex";
export default {
  name: "ServiceEdit",
  components: {
    SwitchSelect,
    LineHr,
    SaveButton,
    PreviewButton,
    DeleteButton,
    TitleEdit,
    InputImageUpload,
    InputEditor,
    InputTextField,
    SelectOption
  },
  computed: {
    ...mapState({
      form: state => {
        return state.Services.form;
      }
    })
  },
  data() {
    return {
      optionBranch: []
    };
  },
  created() {
    this.getBranchData();
  },
  methods: {
    getBranchData() {
      this.$store.dispatch("Branch/getBranchAll").then(res => {
        this.optionBranch = [
          { text: "Select", value: "" },
          ...res.map(type => ({
            value: type.branch_id,
            text: type.branch_name_th + " (" + type.branch_name_en + ")"
          }))
        ];
      });
    },
    validateSave() {
      if (!this.form.branch_id) {
        alert("please select Branch !");
        return false;
      } else if (!this.form.title_th) {
        alert("please insert Service name TH !");
        return false;
      } else if (!this.form.title_en) {
        alert("please insert Service name EN !");
        return false;
      } else if (!this.form.description_th) {
        alert("please insert Description TH !");
        return false;
      } else if (!this.form.description_en) {
        alert("please insert Description EN !");
        return false;
      } else {
        return true;
      }
    },
    saveService() {
      if (this.validateSave()) {
        if (!this.form.branch_id) this.form.branch_id = 1;
        this.$store
          .dispatch("Services/saveService", {
            id: this.form.service_id,
            data: this.form
          })
          .then(res => {
            alert(res.response_msg);
            if (res.response_code == 200) {
              this.goToServiceTable();
            }
          })
          .catch(() => {
            alert("save data fail!");
          });
      }
    },
    deleteService() {
      this.$store
        .dispatch("Services/deleteService", this.form.service_id)
        .then(res => {
          alert(res.response_msg);
          if (res.response_code == 200) {
            this.goToServiceTable();
          }
        })
        .catch(() => {
          alert("delete data fail!");
        });
    },
    goToServiceTable() {
      this.$router.push("/services/service");
    },
    updateOrders(val) {
      this.form.orders = val;
    },
    updateBranch(val) {
      this.form.branch_id = val;
    },
    updateNameTH(val) {
      this.form.title_th = val;
    },
    updateNameEN(val) {
      this.form.title_en = val;
    },
    updateDescriptionTH(val) {
      this.form.description_th = val;
    },
    updateDescriptionEN(val) {
      this.form.description_en = val;
    },
    updateSlugUrl(val) {
      this.form.slug_url = val;
    },
    updateImageIcon(val) {
      this.form.icon = val.imagePath;
      this.form.icon_show = val.fullImagePath;
    }
  }
};
</script>

<style lang="scss" scoped>
.label {
  text-align: right;
}
</style>
